import { render, staticRenderFns } from "./UpdateCourtDialog.vue?vue&type=template&id=35d1f816&"
import script from "./UpdateCourtDialog.vue?vue&type=script&lang=ts&"
export * from "./UpdateCourtDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports